import rules from 'common/helpers/rules';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit('input', {
          ...this.value,
          data: {
            ...this.value?.data,
            ...this.data,
          },
        });
      },
    },
  },
  computed: {
    rules: () => rules,
  },
};
